<template>
    <form class="form" @submit.prevent="handleSubmit">

        <button
            v-if="results.length > 0 && question.key !== '0'"
            type="button"
            @click="$router.back()"
            class="step-button step-back"
            :class="{ 'is-disabled': !prevStep }"
        >
            <span class="sr-only">Back</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85.001" viewBox="0 0 85 85.001">
                <path data-name="Subtraction 2" d="M16890.5,15192a42.369,42.369,0,1,1,16.541-3.34A42.23,42.23,0,0,1,16890.5,15192Zm-.018-37.5v13l28.631-18-28.631-18v13h-23.512v10Z" transform="translate(-16848 -15107.001)" fill="#cc0633"/>
            </svg>
        </button>
        <slot></slot>

        <div class="choices-container">
            <div v-if="stepIncomplete" class="notice">
                Please make a selection
            </div>
        </div>

        <Choices :question="question" @setTouched="setTouched" />

        <p v-if="question.supportingText" class="supporting">
            <small>{{ question.supportingText }}</small>
        </p>

        <button type="submit" class="step-button step-next" :class="activeButton">
            <span class="sr-only">Next</span>
            <svg class="next-inactive" xmlns="http://www.w3.org/2000/svg" width="85" height="85.001" viewBox="0 0 85 85.001">
                <path d="M16890.5,15192a42.369,42.369,0,1,1,16.541-3.34A42.23,42.23,0,0,1,16890.5,15192Zm-.018-37.5v13l28.631-18-28.631-18v13h-23.512v10Z" transform="translate(-16848 -15107.001)" fill="#e6e7e8"/>
            </svg>
            <svg class="next-active" xmlns="http://www.w3.org/2000/svg" width="85" height="85.001" viewBox="0 0 85 85.001">
                <path d="M16890.5,15192a42.369,42.369,0,1,1,16.541-3.34A42.23,42.23,0,0,1,16890.5,15192Zm-.018-37.5v13l28.631-18-28.631-18v13h-23.512v10Z" transform="translate(-16848 -15107.001)" fill="#cc0633"/>
            </svg>
        </button>

    </form>
</template>

<script>
    // @ is an alias to /src
    import Choices from "./Choices";
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "Form",
        props: ["question"],
        components: {
            Choices,
        },
        data() {
            return {
                choice: null,
                choices: [],
                completeAttempted: false,
            };
        },
        watch: {
            '$store.state.results': function() {
                console.log(this.$store.state.results)
                if( this.$store.state.results.length == 0) {
                    this.choice = null;
                    this.choices = [];
                }
            }
        },
        mounted() {
            const savedResult = this.results.find(
                (result) => result.key == this.question.key
            );
            if (savedResult) {
                console.log({ savedResult });
                // load result and set its value for the form
                if (savedResult.type == "checkbox") {
                    console.log(savedResult.selection);
                    this.choices = this.question.options.filter(
                        (option) => savedResult.selection.includes(option.name)
                    ).map( option => option.name );

                    [...savedResult.selection];
                } else {
                    this.choice = this.question.options.find(
                        (option) => option.value == savedResult.selection
                    ).value;
                }
            }
        },
        methods: {
            ...mapMutations([
                "setPathway",
                "setResult",
                "setPrevStep",
                "setResultValue",
                "updateResult",
            ]),

            // goBack() {
            //     const prevUrl = this.prevStep.key;

            //     const params =
            //         prevUrl !== 0 ? { level: this.prevStep.key } : null;

            //     const currentIndex = this.results.findIndex((result) => {
            //         return result.key == this.question.key;
            //     });

            //     // set new prev step URL
            //     const newPrevStep =
            //         currentIndex > 0
            //             ? this.results[currentIndex - 1]
            //             : this.results[0];
            //     this.setPrevStep(newPrevStep);

            //     this.$router.push({
            //         name: "pathway",
            //         params,
            //     });
            // },

            setTouched(data) {
                this.completeAttempted = false;
                if (data.type == "checkbox") {
                    this.choices = data.value;
                } else {
                    this.choice = data.value;
                }
            },

            saveResult(type) {
                const hasResultSavedIndex = this.results.findIndex((result) => {
                    return result.key == this.question.key;
                });

                console.log({ hasResultSavedIndex });

                // only push to array if nothing present
                if (hasResultSavedIndex < 0) {
                    console.log("save new result");
                    this.setResult({
                        ...this.question,
                        selection:
                            type == "checkbox"
                                ? [...this.choices]
                                : this.choice,
                    });
                    return;
                }

                // if the value is different, update it
                if (
                    (hasResultSavedIndex) =>
                        0 &&
                        this.results[hasResultSavedIndex].selection ==
                            this.choice
                ) {
                    console.log("update result");
                    this.updateResult({
                        ...this.question,
                        selection:
                            type == "checkbox"
                                ? [...this.choices]
                                : this.choice,
                    });
                }
            },

            handleSubmit(e) {
                e.target.blur();
                console.log("handle submit");
                this.completeAttempted = true;

                const choice = this.choice;
                const choices = this.choices;

                this.setPrevStep(this.question);

                if (this.question.type == "checkbox") {
                    this.saveResult("checkbox");

                    // reset local values before changing
                    // (this.completeAttempted = false), (this.choices = []);

                    // checkboxes is a final step, go to results
                    if( this.choices.length > 0) {
                        this.$router.push({
                            name: "results",
                        });
                    }
                } else {
                    const selectedOption = this.question.options.find(
                        (option) => option.value == this.choice
                    );

                    if (selectedOption.results == true) {
                        this.saveResult();
                        this.choice == null;

                        this.$router.push({
                            name: "results",
                        });
                    } else {
                        if (this.choice) {
                            this.setPathway(choice);
                            this.saveResult();

                            (this.completeAttempted = false),
                                (this.choice = null);

                            this.$router.push({
                                name: "pathway",
                                params: {
                                    level: choice,
                                },
                            });
                        }
                    }
                }
            }, // end handleSubmit
        },
        computed: {
            ...mapState({
                currentStep: (state) => state.currentStep,
                prevStep: (state) => state.prevStep,
                results: (state) => state.results,
                pathway: (state) => state.pathway,
                resultsValue: (state) => state.resultsValue,
            }),

            stepIncomplete() {
                if (this.question.type == 'checkbox') {
                    return this.choices.length < 1 && this.completeAttempted;
                } else {
                    return this.choice == null && this.completeAttempted;
                }
            },

            activeButton() {
                if( this.question.type == 'checkbox') {
                    return this.choices.length > 0 ? 'is-active' : '';
                } else {
                    return this.choice !== null ? 'is-active' : '';
                }
            }
        },
    };
</script>

<style scoped>
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .form {
        animation: fadeIn 1s;
        text-align: left;
        position: relative;
        padding: 0 1rem;
    }

    .choices-container {
        margin: 0 auto;
        padding: 0;
    }

    @media (min-width: 900px) {
        .form {
            padding: 0 7rem;
        }

        .choices-container {
            padding: 0 2rem;
        }
    }

    .step-button {
        appearance: none;
        background: none;
        border: none;
        /* border-radius: 50%; */
        display: block;
        /* border: 2px solid #fff; */
        position: relative;
        height: 48px;
        width: 48px;
        cursor: pointer;
        position: absolute;
        top: 0;
        line-height: 1;
        transition: all 0.4s ease-out;
    }

    /* .step-button:before {
        content: '';
        border: 2px #e6e6e6 solid;
        display: block;
        border-radius: 50%;
        position: absolute;
        top: -4px;
        left: -4px;
        height: calc(100% + 8px);
        width: calc(100% + 8px);
    } */

    .step-button svg {
        width: 48px;
        height: 48px;
        margin: 1px auto 0;
        top: 5px;
        left: 8px;
        position: absolute;
    }

    .step-next .next-active {
        display: none;
    }
    .step-next.is-active .next-inactive {
        display: block;
    }

    .step-next.is-active .next-active {
        display: block
    }

    .step-next.is-active .next-inactive {
        display: none;
    }


     .step-button.step-back {
         left: 1rem;
         transform-origin: center;
         transform: scaleX(-1);
    }

    .step-button.step-next {
        right: 1rem;
    }

    @media (min-width: 900px) {
        .step-button {
            /* border: 8px solid #fff; */
            /* height: 87px;
            width: 87px; */
            width: 85px;
            height: 85px;
        }

        .step-button svg {
            width: 85px;
            height: 85px;
            /* left: 15px; */
            top: calc(50% - 1px);
            transform: translateY(-50%);
        }

        .step-button.step-next svg {
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
        }
    }


    .notice {
        font-size: 18px;
        text-align: center;
        margin-bottom: 1rem;
    }

    .supporting {
        text-align: center;
        margin-top: 2rem;
    }
</style>
